import { useWidgetData } from '../../../context/widgetDataContext';
import { DirectionWidgetData } from '../types';
import { DateYMDString } from '@lt/api/dist/types/date';

export const useChangeSearchParams = () => {
  const { setData } = useWidgetData<DirectionWidgetData>();

  const changeDeparture = (departure: number) => {
    setData((prev) => ({
      ...prev,
      searchParams: {
        ...prev.searchParams,
        departure,
      },
    }));
  };

  const changeStartDate = (start_date: DateYMDString) => {
    setData((prev) => ({
      ...prev,
      searchParams: {
        ...prev.searchParams,
        start_date,
      },
    }));
  };

  const changeNightsStart = (min: number) => {
    setData((prev) => ({
      ...prev,
      searchParams: {
        ...prev.searchParams,
        nights: {
          ...prev.searchParams.nights,
          min,
        },
      },
    }));
  };
  const changeNightsEnd = (max: number) => {
    setData((prev) => ({
      ...prev,
      searchParams: {
        ...prev.searchParams,
        nights: {
          ...prev.searchParams.nights,
          max,
        },
      },
    }));
  };
  const changeAdults = (adults: number) => {
    setData((prev) => ({
      ...prev,
      searchParams: {
        ...prev.searchParams,
        adults,
      },
    }));
  };
  const changeKids = (kids: number[]) => {
    setData((prev) => ({
      ...prev,
      searchParams: {
        ...prev.searchParams,
        kids,
      },
    }));
  };
  const changeNights = (nights: DirectionWidgetData['searchParams']['nights']) => {
    setData((prev) => ({
      ...prev,
      searchParams: {
        ...prev.searchParams,
        nights,
      },
    }));
  };

  const changeFlexNights = () => {
    setData((prev) => ({
      ...prev,
      searchParams: {
        ...prev.searchParams,
        flexNights: !prev.searchParams.flexNights,
      },
    }));
  };

  return {
    changeDeparture,
    changeStartDate,
    changeNightsStart,
    changeNightsEnd,
    changeAdults,
    changeKids,
    changeNights,
    changeFlexNights,
  };
};
